import { Props, RenewalStatus } from './MentorRenewalPopup.model';
import { useMentorRenewalPopup } from './useMentorRenewalPopup';
import styles from './MentorRenewalPopup.module.scss';
import Popup from '../Popup/Popup';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from '../Icon/Icon';
import { Button } from 'antd';
import { Controller } from 'react-hook-form';
import TextArea from 'antd/lib/input/TextArea';

const MentorRenewalPopup = ({ onClose, user }: Props) => {
	const {
		approveRenewal,
		control,
		handleSubmit,
		rejectRenewal,
		setStatus,
		setStep,
		state: { status, step },
	} = useMentorRenewalPopup({ onClose, user });

	const intl = useIntl();

	const renderStep1 = () => {
		return (
			<div className={styles.step1}>
				<h3>
					<FormattedMessage id="renewal.step1.subtitle" />
				</h3>
				<h1>
					<FormattedMessage
						id="renewal.step1.title"
						values={{ b: (chunks: any) => <b>{chunks}</b>, name: user.name }}
					/>
				</h1>
				<div className={styles.description}>
					<Icon
						name="user"
						type="solid"
						color="accent"
						width="32px"
						height="32px"
					/>
					<span>
						<FormattedMessage
							id="renewal.step1.description.demote"
							values={{ b: (chunks: any) => <b>{chunks}</b> }}
						/>
					</span>
				</div>
				<div className={styles.description}>
					<Icon
						name="user"
						type="solid"
						color="green"
						width="32px"
						height="32px"
					/>
					<span>
						<FormattedMessage
							id="renewal.step1.description.renew"
							values={{ b: (chunks: any) => <b>{chunks}</b> }}
						/>
					</span>
				</div>
				<div className={styles.btnWrapper}>
					<Button
						type="primary"
						size="large"
						className={styles.orangeBtn}
						onClick={() => {
							setStatus(RenewalStatus.Rejected);
							setStep(2);
						}}
					>
						<FormattedMessage id="buttons.demote" />
					</Button>
					<Button
						type="primary"
						size="large"
						onClick={() => {
							setStatus(RenewalStatus.Approved);
							setStep(2);
						}}
					>
						<FormattedMessage id="buttons.renew" />
					</Button>
				</div>
			</div>
		);
	};

	const renderStep2 = () => {
		return (
			<div
				className={`${styles.step2} ${
					status === RenewalStatus.Rejected && styles.rejected
				}`}
			>
				<h1>
					<FormattedMessage
						id={`renewal.step2.${status}.title`}
						values={{ b: (chunks: any) => <b>{chunks}</b>, name: user.name }}
					/>
				</h1>
				<div className={styles.fieldWrapper}>
					<span className={styles.floatingLabel}>
						<FormattedMessage id="formLabels.message" />
					</span>
					<Controller
					control={control}
					name="message"
					render={({ field }) => <TextArea {...field} placeholder={intl.formatMessage({id: "formPlaceholders.message"})} rows={10}/>}
					rules={{ required: status === RenewalStatus.Rejected }}
				/>
				</div>
			</div>
		);
	};

	const renderStep3 = () => {
		return (
			<div className={styles.step3}>
				<div className={`${styles.content} ${styles.scrollable}`}>
					<span className={styles.closeIcon} onClick={onClose}>
						<Icon name="times" color="black" />
					</span>
					<Icon
						className={styles.icon}
						color="green"
						name="badge-check"
						type="light"
					/>
					<h1>
						<FormattedMessage id="renewal.thankYou.title" />
					</h1>
					<Button type="link" onClick={onClose}>
						<FormattedMessage id="buttons.finish" />
					</Button>
				</div>
			</div>
		);
	};

	const renderSteps = () => {
		switch (step) {
			case 1:
				return renderStep1();
			case 2:
				return renderStep2();
			case 3:
				return renderStep3();
			default:
				return renderStep1();
		}
	};
	return (
		<Popup
			contentExtraClass={step === 2 && status ? styles[status] : ''}
			onClose={onClose}
			height="full-height"
			size="extra-small"
			actions={
				step === 2 ? (
					<>
						<Button
							className={styles.blueBtn}
							size="large"
							type="link"
							onClick={() => {
								setStep(1);
							}}
						>
							<FormattedMessage id="buttons.back" />
						</Button>
						<Button
							size="large"
							type="primary"
							onClick={
								status === RenewalStatus.Rejected
									? handleSubmit(rejectRenewal)
									: handleSubmit(approveRenewal)
							}
						>
							<FormattedMessage id="buttons.send" />
						</Button>
					</>
				) : <></>
			}
		>
			<div className={styles.popupContent}>{renderSteps()}</div>
		</Popup>
	);
};

export default MentorRenewalPopup;
